<template>
  <div class="footer">
    <div class="inner">
      <div class="hungaria">
        <a
          title="Hungária"
          href="http://www.facebook.com/hungariaextradry"
        >
          <img
            src="../assets/hungaria-footer.svg"
            alt="Hungária"
          >
        </a>
      </div>
      <div class="forbesnext">
        <a
          title="forbes.hu"
          href="https://forbes.hu"
        >
          Tovább a <img
            src="../assets/forbes-foo.svg"
            alt="Forbes"
          > .hu-ra
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {

  },
  methods: {
    show() {
      this.$modal.show('modszertan');
    },
    hide() {
      this.$modal.hide('modszertan');
    },
  },
};
</script>

<style scoped lang="css">
.footer {
  background: #238eb6;
  background: -moz-linear-gradient(
    left,
    #238eb6 0%,
    #8dd7f5 25%,
    #9de2fb 50%,
    #22b1dd 80%,
    #85d8f5 100%
  );
  background: -webkit-linear-gradient(
    left,
    #238eb6 0%,
    #8dd7f5 25%,
    #9de2fb 50%,
    #22b1dd 80%,
    #85d8f5 100%
  );
  background: linear-gradient(
    to right,
    #238eb6 0%,
    #8dd7f5 25%,
    #9de2fb 50%,
    #22b1dd 80%,
    #85d8f5 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#238eb6',
  endColorstr='#85d8f5',GradientType=1 );
}
.inner {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto auto;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
  -ms-grid-rows: auto auto;
  padding: 16px 15px;
  align-items: center;
}
.hungaria {
  grid-column: 1/2;
  grid-row: 1/3;
  -ms-grid-column: 1;
  -ms-grid-row-span: 2;
}
.hungaria img {
  height: 90px;
}
.forbesnext {
  grid-column: 2/3;
  grid-row: 1/3;
  -ms-grid-column: 2;
  -ms-grid-row-span: 2;
  text-transform: uppercase;
  font-size: 18px;
  justify-self: end;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.forbesnext img {
  height: 25px;
  margin-bottom: -1px;
}
.forbesnext a {
  white-space: nowrap;
}
a {
  color: #272727;
  text-decoration: none;
}
@media screen and (max-width: 540px) {
  .hungaria {
    grid-column: 1/3;
    grid-row: 1/2;
    -ms-grid-column-span: 2;
    -ms-grid-row-span: 1;
    margin-bottom: 20px;
    justify-self: center;
  }
  .forbesnext {
    grid-column: 1/3;
    grid-row: 2/3;
    -ms-grid-column-span: 2;
    -ms-grid-row-span: 1;
    justify-self: center;
  }
}
</style>
